export const toToggleGroupValues = (formItemChoices) =>
    formItemChoices.map((c) => ({
        value: c.choiceValueTyped ?? c.choiceValue,
        label: c.choiceText,
    }));
